query GetManagedMeetingsTemplates($archived: Boolean!) {
    managedMeetings(archived: $archived) {
        id
        name
        durationMinutes
        activityType {
            name
            id
        }
        htmlUrlPath
        deletedTime
        assignments {
            totalCount
            edges {
                meetings {
                    id
                    name
                    isSevered
                }
                node {
                    id
                    assigneeEntity {
                        id
                        name
                    }
                }
            }
        }
    }
}
